import { createFileRoute, redirect } from "@tanstack/react-router"

import { PlacesAutocompleteDemoPage } from "@/pages/dev/places-autocomplete-demo"

export const Route = createFileRoute("/_authenticated/settings/dev/demos/places-autocomplete")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: PlacesAutocompleteDemoPage,
})
